var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2653",
    "data-name": "Group 2653",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 15.484,
    viewBox: "0 0 18 15.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1781",
    "data-name": "Rectangle 1781",
    width: 18,
    height: 15.484,
    fill: "#610D24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2652",
    "data-name": "Group 2652",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M16.232,2.91H14.17V2.815A2.81,2.81,0,0,0,11.37,0H6.813a2.81,2.81,0,0,0-2.8,2.814V2.91H1.768A1.77,1.77,0,0,0,0,4.678v9.04a1.77,1.77,0,0,0,1.768,1.768H16.232A1.77,1.77,0,0,0,18,13.717V4.678A1.77,1.77,0,0,0,16.232,2.91m-10.7-.095a1.293,1.293,0,0,1,1.285-1.3H11.37a1.293,1.293,0,0,1,1.285,1.3V2.91H5.529Z",
    transform: "translate(0 -0.001)",
    fill: "#610D24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagSelected);
export default __webpack_public_path__ + "static/media/bag_selected.b9b3857901b854728c9901ca316b7fe7.svg";
export { ForwardRef as ReactComponent };